import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  room: SduiTypes.room
): OutTypes.location => {
  return {
    ids:         room.id,
    displayName: room.name,
  };
};
